<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useResultsStore } from '../stores/results-fetcher.js'

defineProps({
  modelValue: { type: String, default: 'all' }
})
defineEmits(['update:modelValue'])

const resultsStore = useResultsStore()
const visible = computed(() => resultsStore.hasGender())

const options = [
  { value: 'all', label: 'Wszyscy' },
  { value: 'K', label: 'Kobiety' },
  { value: 'M', label: 'Mężczyźni' }
]
</script>

<template>
  <div v-if="visible" class="btn-group btn-group-sm mb-3" role="group" aria-label="Filtr płci">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="btn"
      :class="modelValue === option.value ? 'btn-primary' : 'btn-outline-primary'"
      @click="$emit('update:modelValue', option.value)"
    >{{ option.label }}</button>
  </div>
</template>
